/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TDesktopMarkAllAsReadModel,
  IDesktopMarkAllAsReadRequest,
  IMappers,
  IDesktopMarkAllAsReadResponse,
  IDesktopMarkAllAsReadResponseError,
  TDesktopMarkAllAsReadResponse,
} from './types';

const defaultConfig: TDesktopMarkAllAsReadModel = {
  apiType: 'public',
  assertStatusCodes: [400, 200, 204],
  method: 'POST',
  microserviceName: 'notification-center',
  pathApi: '/v1/desktop/mark-all-as-read/',
  hostType: 'api',
} as TDesktopMarkAllAsReadModel;

function createDesktopMarkAllAsReadModel(parameters: IDesktopMarkAllAsReadRequest): TDesktopMarkAllAsReadModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IDesktopMarkAllAsReadOptions<TResponse400, TResponse200, TResponse204> {
  httpApi: IHttpApi;
  parameters: IDesktopMarkAllAsReadRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400, TResponse200, TResponse204>;
}

async function fetchDesktopMarkAllAsRead<TResponse400, TResponse200, TResponse204>({
  httpApi,
  parameters,
  config,
  mappers,
}: IDesktopMarkAllAsReadOptions<TResponse400, TResponse200, TResponse204>): Promise<
  TResponse400 | TResponse200 | TResponse204 | TDesktopMarkAllAsReadResponse
> {
  const { response, statusCode } = await httpApi.fetch(createDesktopMarkAllAsReadModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as IDesktopMarkAllAsReadResponseError);
    }

    if (statusCode === 200) {
      return mappers[200](response as IDesktopMarkAllAsReadResponse);
    }

    if (statusCode === 204) {
      return mappers[204]();
    }
  }

  return { response, statusCode } as TDesktopMarkAllAsReadResponse;
}

export { defaultConfig, createDesktopMarkAllAsReadModel, fetchDesktopMarkAllAsRead };
